import Api from '@/mixins/list/api';
export default {
    data() {
        return {
            List: [],
            listClass : null,

            paginationType: '',
            hasPre: false,

        }
    },
    methods: {
        initList(type, options) {
            switch (type) {
                case 'api':
                    this.listClass = new Api(options);
                    break;
            }
        },
        getList(isFirst=false) {
            let filterSet = JSON.parse(JSON.stringify(this.getFilterSet()));
            if(isFirst) {
                let parsingDataPage = this.getPasingDataPage();
                filterSet.page.page = parsingDataPage;
                this.List = [];
            }else if(this.isInitPage === true) {
                filterSet.page.page = 1;
                this.setPage('page', 1);
            }
            if(this.listClass === null) {
                return false;
            }
            this.listClass.getList(this.filterSet).then(res => {
                console.log(res);
                let list = res.list.slice();
                if(this.paginationType === 'lazyload' && this.List.length > 0 && this.hasPre) {
                    this.List = list.concat(this.List.slice());
                }else if(this.paginationType === 'lazyload' && this.List.length > 0) {
                    this.List = this.List.concat(list.slice());
                }else{
                    this.List = list.slice();
                }
                if(res.hasOwnProperty('total')) {
                    this.setPage('total', res.total);
                }
                if(isFirst) {
                    this.setParsingDataPageFilterSet();
                }
                this.isInitPage = false;
            })
        },
    },
    watch: {
    }
}
